import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BadInputError } from '../errors/bad-input-error';
import { NotFoundError } from '../errors/not-found-error';
import { UnknownUrlError } from '../errors/unknown-url-error';
import { SispacError } from '../errors/sispac-error';
import { environment } from '../../../../environments/environment';

import 'rxjs/add/observable/throw';

@Injectable()
export class DataService {

  protected urlApi = environment.urlApi;
  protected apiUrlGestaoSS = environment.apiGestaoSSApiUrl;
  protected gestaoSSUrl = environment.apiGestaoSSUrl;

  protected handleError(error: Response) {
    if (error.status === 0) {
      return Observable.throw(new UnknownUrlError(error));
    }

    if (error.status === 400) {
      return Observable.throw(new BadInputError(error));
    }

    if (error.status === 404) {
      return Observable.throw(new NotFoundError(error));
    }

    return Observable.throw(new SispacError(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/services/data.service.ts